import { render, staticRenderFns } from "./UserEditTabNotification.vue?vue&type=template&id=71b97794"
import script from "./UserEditTabNotification.vue?vue&type=script&lang=js"
export * from "./UserEditTabNotification.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabNotification.vue?vue&type=style&index=0&id=71b97794&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports